import { render } from "./Comparison.vue?vue&type=template&id=03b98f22&scoped=true"
import script from "./Comparison.vue?vue&type=script&lang=js"
export * from "./Comparison.vue?vue&type=script&lang=js"

import "./Comparison.vue?vue&type=style&index=0&id=03b98f22&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b98f22"]])

export default __exports__